import { NumberInput, type NumberInputProps } from "@mantine/core";

/** The years a year field takes (the API's limits too). */
export const YEARS = { min: 1900, max: 2100 } as const;

/** A year field: a whole number between 1900 and 2100. */
export function YearInput(props: NumberInputProps) {
  return <NumberInput w={90} allowDecimal={false} min={YEARS.min} max={YEARS.max} {...props} />;
}
